import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white recent-activity-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-15 mb-md-20 mb-xxxl-25 d-flex align-items-center justify-content-between\"><h5 class=\"card-title fw-bold mb-0\">Recent Activity</h5><div class=\"dropdown\"><button class=\"dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"flaticon-dots\"></i></button><ul class=\"dropdown-menu\"><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-view lh-1 me-8 position-relative top-1\"></i> View </a></li><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-pen lh-1 me-8 position-relative top-1\"></i> Edit </a></li><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-delete lh-1 me-8 position-relative top-1\"></i> Delete </a></li></ul></div></div>", 1)
const _hoisted_4 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_5 = { class: "position-relative fw-medium text-dark-emphasis" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-envelope-simple" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "J. Ronan", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-1" }, "35 mins ago", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
const _hoisted_10 = { class: "position-relative fw-medium text-dark-emphasis" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-first-aid-kit" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "Victoria", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "Board for Project", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-1" }, "1 hr ago", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
const _hoisted_16 = { class: "position-relative fw-medium text-dark-emphasis" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-check-circle" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "Walter White", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "“The Dashboard”", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-1" }, "2 hrs ago", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
const _hoisted_22 = { class: "position-relative fw-medium text-dark-emphasis" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-shield-plus" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "Jennifer", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "Micheal", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "“The Adlash Design”", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-1" }, "3 hrs ago", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
const _hoisted_29 = { class: "position-relative fw-medium text-dark-emphasis" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-envelope-simple" })
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, "S. Smith", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-1" }, "1 day ago", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createTextVNode(" sent an Email "),
          _hoisted_8,
          _createVNode(_component_router_link, {
            to: "/project-management",
            class: "link-btn text-decoration-none position-absolute end-0"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createTextVNode(" archived a "),
          _hoisted_13,
          _createTextVNode(" in team "),
          _hoisted_14,
          _createVNode(_component_router_link, {
            to: "/project-management",
            class: "link-btn text-decoration-none position-absolute end-0"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createTextVNode(" completed the project "),
          _hoisted_19,
          _hoisted_20,
          _createVNode(_component_router_link, {
            to: "/project-management",
            class: "link-btn text-decoration-none position-absolute end-0"
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_22, [
          _hoisted_23,
          _hoisted_24,
          _createTextVNode(" added "),
          _hoisted_25,
          _createTextVNode(" in the project "),
          _hoisted_26,
          _hoisted_27,
          _createVNode(_component_router_link, {
            to: "/project-management",
            class: "link-btn text-decoration-none position-absolute end-0"
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_29, [
          _hoisted_30,
          _hoisted_31,
          _createTextVNode(" sent an Email "),
          _hoisted_32,
          _createVNode(_component_router_link, {
            to: "/project-management",
            class: "link-btn text-decoration-none position-absolute end-0"
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}